var map = {
	".": 298,
	"./": 298,
	"./Modules.Action": 367,
	"./Modules.Action.ts": 367,
	"./Modules.State": 1539,
	"./Modules.State.ts": 1539,
	"./UI.New": 1540,
	"./UI.New.tsx": 1540,
	"./UI.Old": 2126,
	"./UI.Old.tsx": 2126,
	"./icon/1.svg": 6907,
	"./icon/2.svg": 6908,
	"./image/1.png": 6909,
	"./image/2.png": 6910,
	"./image/3.png": 6911,
	"./image/4.png": 6912,
	"./image/5.png": 6913,
	"./image/6.png": 6914,
	"./image/7.png": 6915,
	"./image/8.png": 6916,
	"./image/9.png": 6917,
	"./image/old.png": 6918,
	"./index": 298,
	"./index.scss": 555,
	"./index.tsx": 298
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2125;


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Guide ^.*$
// module id = 2125
// module chunks = 0